import { IsNullOrEmptyHtml } from "helpers/stringHelper";
import { useCurrentCompany } from "hooks/auth";
import React from "react";

import { AdditionalMessageDisplay } from "./components/AdditionalMessageDisplay";
import { ButtonLink } from "./components/ButtonLink";
import { ProcuraconMailLayout } from "./components/ProcuraconMailLayout";
import dayjs from "dayjs";

interface PanelMeetingInvitationEmailContentProps {
	additionalMessage?: string;
	meetingDate: Date;
	meetingLocation?: string;
	meetingTime: string;
	meetingTImeZone: string;
	rfxLeadName: string;
	rfxTitle: string;
};

const CELL_CLASSES = "";

const StyledCell = ({ children }) => {
	return (
		<td
			style={{
				fontFamily: "Arial, sans-serif",
				fontSize: "16px",
				lineHeight: "24px",
				color: "#374151",
				paddingBottom: "20px",
			}}
		>
			{children}
		</td>
	);
};

export const PanelMeetingInvitationEmailContent: React.FC<
	PanelMeetingInvitationEmailContentProps
> = ({ additionalMessage, meetingDate, meetingLocation, meetingTime, meetingTImeZone, rfxTitle, rfxLeadName }) => {
	const currentCompany = useCurrentCompany();

	const hasAdditionalText = !IsNullOrEmptyHtml(additionalMessage);
	const formattedMeetingDate = dayjs(meetingDate).format("MMMM D, YYYY");
	const formattedMeetingTime = dayjs(meetingTime, "HH:mm").format("h:mm A");
	const fullMeetingTime = `${formattedMeetingTime} ${meetingTImeZone}`;

	return (
		<ProcuraconMailLayout
			emailToName={"[Recipient Name]"}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					You have been invited to a panel meeting for <b>{rfxTitle}</b> by <b>{rfxLeadName}</b> from <b>{currentCompany.name}</b>.
				</td>
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "40px",
					}}
				>
					<b>Date:</b> {formattedMeetingDate}
					<br />
					<b>Time:</b> {fullMeetingTime}
				</td>
			</tr>
			{meetingLocation && <tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "40px",
					}}
				>
					<b>Location:</b> {meetingLocation}
				</td>
			</tr>}
			{hasAdditionalText && (
				<>
					<tr>
						<td
							style={{
								fontFamily: "Arial, sans-serif",
								fontSize: "16px",
								lineHeight: "24px",
								color: "#374151",
							}}
						>
							Message form the organiser:
						</td>
					</tr>
					<AdditionalMessageDisplay
						additional_message={additionalMessage}
						className="italic"
					/>
				</>
			)}
			<tr>
				<StyledCell>
					A calendar invitation (.ics) is attached to this email for your convenience.
				</StyledCell>
			</tr>
			<tr>
				<StyledCell>
					Should you have any questions, feel free to contact the meeting organiser directly.
				</StyledCell>
			</tr>
		</ProcuraconMailLayout>
	);
};
